import React from 'react';
import classnames from 'classnames';

export interface BoxProps {
  header?: React.ReactNode;
  body: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  headerClassName?: string;
  bodyStyle?: React.CSSProperties;
  noPadding?: boolean;
  divider?: boolean;
  style?: React.CSSProperties;
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      header,
      body,
      className = 'box-default',
      bodyStyle,
      bodyClassName,
      divider = true,
      style,
      headerClassName,
      noPadding
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`box ${className ? className : ''}`}
        style={style}
      >
        {header && (
          <div className={classnames('box-header', headerClassName)}>
            {header}
          </div>
        )}
        {header && divider && <div className="box-divider" />}
        <div
          className={`box-body ${bodyClassName ? bodyClassName : ''} ${
            noPadding ? 'no-padd' : ''
          }`}
          style={bodyStyle}
        >
          {body}
        </div>
      </div>
    );
  }
);

export default Box;
